module.exports = __webpack_public_path__ + "static/C2-dc5edea3f754a6072e0b43b1de7b6e2c.jpg";